import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { Avatar, Dropdown, ThemeToggle } from '../ui';
import { useAuthStore } from '../../stores';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  onMenuClick: () => void;
  title?: string;
}

export const Header: React.FC<HeaderProps> = ({ onMenuClick, title }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const dropdownItems = [
    {
      label: 'Settings',
      onClick: () => navigate('/settings'),
    },
    {
      label: 'Logout',
      onClick: handleLogout,
      danger: true,
    },
  ];

  return (
    <header className="sticky top-0 z-20 bg-white dark:bg-secondary-900 border-b border-secondary-200 dark:border-secondary-700 transition-colors duration-200">
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        <div className="flex items-center">
          <button
            onClick={onMenuClick}
            className="p-2 -ml-2 text-secondary-500 hover:text-secondary-700 dark:text-secondary-400 dark:hover:text-secondary-200 lg:hidden"
          >
            <Bars3Icon className="w-6 h-6" />
          </button>
          {title && (
            <h1 className="ml-2 lg:ml-0 text-xl font-semibold text-secondary-900 dark:text-secondary-50">{title}</h1>
          )}
        </div>

        <div className="flex items-center space-x-2">
          {/* Theme Toggle */}
          <ThemeToggle />

          {/* Notifications - temporarily suppressed
          <button className="relative p-2 text-secondary-500 hover:text-secondary-700 hover:bg-secondary-50 dark:text-secondary-400 dark:hover:text-secondary-200 dark:hover:bg-secondary-800 rounded-lg transition-colors">
            <BellIcon className="w-6 h-6" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-danger-500 rounded-full" />
          </button>
          */}

          {/* User Menu */}
          <Dropdown
            trigger={
              <button className="flex items-center space-x-3 p-1.5 rounded-lg hover:bg-secondary-50 dark:hover:bg-secondary-800 transition-colors">
                {user && (
                  <Avatar
                    firstName={user.firstName}
                    lastName={user.lastName}
                    src={user.avatar}
                    size="sm"
                  />
                )}
                <div className="hidden md:block text-left">
                  <p className="text-sm font-medium text-secondary-900 dark:text-secondary-50">
                    {user?.firstName} {user?.lastName}
                  </p>
                  <p className="text-xs text-secondary-500 dark:text-secondary-400">
                    {user?.roleDisplayName}
                  </p>
                </div>
              </button>
            }
            items={dropdownItems}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;



